var WebClientConstants = {
    DISPATCHER: "SHARED_WEB_CLIENT_DISPATCHER",
    SET_EXPORT_GLB: "SET_EXPORT_GLB",
    SET_EXPORT_OBJ: "SET_EXPORT_OBJ"
};

export default WebClientConstants;